import styled from 'styled-components';
import { FlexBox } from '@agilepoint/wat-react-ux';
import { toCamelCasedKeys } from '@agilepoint/utils-common';
import { useTranslate } from '@agilepoint/wat-react';
import { CenteredSpinner } from 'common';
import { NotificationContent } from '../component/parts/notifications';
import { useAllNotificationQuery } from '../queries';

const StyledFlexBox = styled(FlexBox)`
    padding: 10px;
    width: 280px;
    height: 346px;
`;

interface INotificationDetailsContainerProps {
    showHideCallout: (value: boolean) => void;
}

export function NotificationDetailsAdminContainer(props: INotificationDetailsContainerProps) {
    const { data, isLoading } = useAllNotificationQuery();
    const translate = useTranslate();

    if (isLoading) {
        return (
            <StyledFlexBox>
                <CenteredSpinner size='small' spinnerType='indeterminate' text={translate('modules.defaultAppSettings.notificationList.loadingNotificationText')} />
            </StyledFlexBox>
        );
    }

    if (data) {
        const info = toCamelCasedKeys(data, true);
        return (
            <NotificationContent notificationDetails={info.getAllNotificationsResult} showHideCallout={props.showHideCallout} />
        );
    }

    return (
        <></>
    );
}
